<template>
	<div class="pa-2">
		<B-confirm-edit-dialog
			ref="dialog"
			@on-consent="addEmployee"
		></B-confirm-edit-dialog>
		<div class="d-flex mb-2">
			<v-spacer></v-spacer>
			<input
				v-show="0"
				ref="addAttachment"
				type="file"
				@change="addAttachment" />
			<v-btn
				:loading="loadingAddingEmployee || loadingFetchEmployee || loadingAddAttachment"
				:disabled="loadingAddingEmployee || loadingFetchEmployee || loadingAddAttachment"
				color="primary"
				small
				@click="$refs.addAttachment.click()">
				<v-icon
					size="20"
					left>
					$add
				</v-icon>
				إضافة مرفق
			</v-btn>
		</div>
		<bee-handy-table
			:items="attachmentsItems"
			:headers="attachmentsHeaders"
			:loading="loading"
			zebra
			fixed-header
			height="65vh"
			hide-default-footer>
			<template v-slot:item.name="{ item, header, getShownValueInCell }">
				<a
					:href="item.filePath"
					target="_blank"
					class="d-flex align-center py-1">
					<v-img
						:src="typeIcon[item.type] || typeIcon.default"
						max-height="3rem"
						max-width="3rem"
						class="ml-2"></v-img>

					{{ getShownValueInCell({ item, header }) }}
				</a>
			</template>
			<template v-slot:item.actions="{}">
				<div class="d-flex">
					<tooltip :text="$T('tooltips.preview')">
						<v-btn
							small
							icon>
							<v-icon
								size="20"
								color="preview">
								$view
							</v-icon>
						</v-btn>
					</tooltip>
					<tooltip :text="$T('tooltips.delete')">
						<v-btn
							small
							icon>
							<v-icon
								size="20"
								color="alert">
								$delete
							</v-icon>
						</v-btn>
					</tooltip>
				</div>
			</template>
		</bee-handy-table>
		<v-divider class="mt-4 mb-3"></v-divider>
		<div class="d-flex">
			<v-btn
				color="primary"
				:to="{ name: 'practical-experiences', query: { employeeId: $route.query.employeeId } }">
				<v-icon left> mdi-share </v-icon>
				{{ $T('default-buttons.prev') }}
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				class="px-10 mx-2"
				@click="$refs.dialog.activeConfirmDialog()"
				color="success"
				:loading="loadingAddingEmployee || loadingFetchEmployee"
				:disabled="loadingAddingEmployee || loadingFetchEmployee || disableSave">
				{{ employeeId ? 'تعديل ملف الموظف' : 'إنشاء ملف الموظف' }}
			</v-btn>
			<!-- <v-btn
				color="primary"
				:to="{ name: 'employee-attachments', query: { employeeId: $route.query.employeeId } }">
				{{ $T('default-buttons.next') }}
				<v-icon right> mdi-reply </v-icon>
			</v-btn> -->
		</div>
	</div>
</template>

<script>
import BConfirmEditDialog from '@/components/forms/BConfirmEditDialog'

const typeIcon = {
	jpg: require('@/assets/attachments/id.jpg'),
	pdf: require('@/assets/attachments/pdf.png'),
	excel: require('@/assets/attachments/excel.png'),
	default: require('@/assets/attachments/file.png'),
};

export default {
	components: { BConfirmEditDialog },

	name: 'EmployeeAttachments',

	props: {
		loadingFetchEmployee: { type: Boolean },
		loadingAddingEmployee: { type: Boolean },
		employeeInfo: { type: Object, default: () => ({}) },
		employeeId: { type: String },
		editingEmployee: { type: Boolean, default: false },
		disableSave: { type: Boolean, default: false },
	},

	data() {
		return {
			loading: false,
			loadingAddAttachment: false,

			attachmentsHeaders: [
				{ text: this.$T('name'), name: 'name', value: 'name', sortable: false },
				{ text: this.$T('type'), name: 'type', value: 'type', sortable: false },
				// { text: '', name: 'actions', value: 'actions', width: 40, sortable: false },
			],
			attachmentsItems: [],

			typeIcon,
		};
	},

	methods: {
		addAttachment(e) {
			if (!e.target.files[0]) return;

			this.loadingAddAttachment = true;
			this.$store
				.dispatch('employee/addAttachment', {
					employeeId: this.employeeId,
					file: e.target.files[0],
				})
				.then(() => {
					this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), { done: true });
					this.fetch();
				})
				.catch((err) => {
					err.default && err.default(this.$T('messages.add-fail'), false);
				})
				.finally(() => {
					this.loadingAddAttachment = false;
				});
		},

		fetch() {
			this.loading = true;
			this.$store
				.dispatch('employee/getAttachments', this.employeeId)
				.then((res) => {
					this.attachmentsItems = res;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		addEmployee() {
			this.$refs.dialog.deactivateConfirmDialog()
			this.$emit('add-employee', {});
		},
	},

	mounted() {
		this.fetch();
	},
};
</script>
